var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"ml10 down-btn",attrs:{"type":"primary"},on:{"click":_vm.downPdf}},[_vm._v("\n    群体报告下载\n  ")]),_c('ReportListDialog',{ref:"ReportList",attrs:{"search-params":_vm.searchParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }